import React from 'react'
import Slider from 'react-slick'
import { connect } from 'react-redux'
import {Link} from 'react-router-dom'
import {
  fetchEventsIfNeeded,
  invalidateEvents
} from '~/events/actions'
import {
  fetchNodeIfNeeded,
} from '~/nodes/actions'
import { DateTime } from 'luxon'
import { unique } from 'underscore'
import { makeSafeForCSS } from '~/helpers'


const EventBox = (props) => {
  const { event } = props;
  
  return (
    <div className="event-item">
      <div className="poster">
        <img src={event.field_event_image.length ? 'https://jeff.4zzz.org.au' + event.field_event_image : 'https://jeff.4zzz.org.au/sites/default/files/default_images/noevent.png' } />
      </div>
      <div className="info">
        <h2 data-title={event.title}>{event.title}</h2>
        <div className="copy-box" style={{ display: 'flex', gap: '16px' }}>
          <div style={{ flex: '0 0 33.3%', display: 'flex', flexDirection: 'column', gap: '8px'}}>
            <div className='date'>{ DateTime.fromISO(event.field_event_date).toLocaleString(DateTime.DATE_HUGE) }</div>
            <div className="venue"><span>Venue: {event.venue}</span></div>
            <div className='cost'>{event.field_event_cost}</div>

            
            {event.tickets &&  <div style={{margin: '32px 0'}}><a href={event.tickets} className="button">Get Tickets</a></div>}
            <div className="tags">
            { event.tags.split(', ').map((tag, n) => <div key={n}><span className={'tag ' + makeSafeForCSS(tag) }>{tag}</span></div> ) }
            </div>
          </div>

          <div style={{flex: 1}} dangerouslySetInnerHTML={{ __html: event.body }}></div>

        </div>
      </div>
    </div>
)}

const EventBoxes = (props) => {
  const { index, event, clickHandler } = props;

  return (
    <div onClick={(e) => clickHandler(event, e)} className={event.zed_event.length === 0 || event.zed_event[0].value === false ? "event-box zed-presents " +  makeSafeForCSS(event.category) : "event-box zed-event " +  makeSafeForCSS(event.category)} key={index}>
      <div className="header"> </div>
      <img src={event.field_event_image.length ? 'https://jeff.4zzz.org.au' + event.field_event_image : 'https://jeff.4zzz.org.au/sites/default/files/default_images/noevent.png' }/>
      <div className="date"><span>{ DateTime.fromISO(event.field_event_date).toFormat('ccc d MMM') }</span>
      { event.tags.split(', ').map((tag, n) => tag !== event.category && <span key={n} className={'tag ' + makeSafeForCSS(tag) } >&nbsp;</span> ) }
      </div>
      <h3 data-title={event.title}><span>{event.title}</span></h3>
      <div className="teaser" ><span dangerouslySetInnerHTML={{ __html: event.field_event_teaser }}></span></div>
      <div style={{flex: 1}}></div>
      <div className="venue"><span>Venue: {event.venue}</span></div>
      {/* <div className="footer"></div> */}
      {/*<div>{item.field_event_teaser[0].value}</div>*/}
    </div>
  )
}

class FiftyEvents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventItem: null,
      visible: false,
      filters: ['All', 'Music', '18+', 'Party']
    }
    this.clicked = this.clicked.bind(this)
  }

  componentDidMount(){
    const {dispatch} = this.props
    return Promise.all([

      dispatch(fetchEventsIfNeeded()), 
      dispatch(fetchNodeIfNeeded('4ZZZ50-program-information'))
    ])
  }
  componentWillReceiveProps(props) {
    const { match, dispatch, nodes } = props
    if (match && match.params && match.params.id)
    {
      let id = match.params.id
      if(id) {
        dispatch(fetchNodeIfNeeded(id))
        if(nodes[id] && nodes[id].body) {
          this.setState( {eventItem: nodes[id]} )
        }
      }
    }

    let tags = []
    props.events.items.forEach(i =>  { tags = [...tags, ...i.tags.split(', ')] } );
    let uniqueTags = tags.filter((row, index, arr) => arr.findIndex(row2 => row2 === row) >= index);
    this.setState( {filters: ['All', ...uniqueTags]} );
}

  clicked(item){
    console.log(item)
    this.setState( {eventItem: item} )


    let months = this.props.events.items.map(i => [DateTime.fromISO(i.field_event_date).toFormat('M'), DateTime.fromISO(i.field_event_date).toFormat('LLL')] )

    
    let uniqueMonths = months.filter((row, index, arr) => arr.findIndex(row2 => row2[0] === row[0]) >= index);
    console.log(uniqueMonths)

  }

  setFilter(tag) {
    console.log(tag)
    const addOrRemove = (arr, item) => arr.includes(item) ? arr.filter(i => i !== item) : [ ...arr, item ];
    this.setState( state => {
      if (tag === 'All') {
        let tags = []
        this.props.events.items.forEach(i =>  { tags = [...tags, ...i.tags.split(', ')] } )
        let uniqueTags = tags.filter((row, index, arr) => arr.findIndex(row2 => row2 === row) >= index);
        return state.filters.includes('All') ? {filters: []} : {filters: ['All', ...uniqueTags]};
      }
      else {
        let tags = state.filters.includes('All') ? addOrRemove(state.filters, 'All') : state.filters;
       return ({ filters: addOrRemove(tags, tag) })

      }
    })

    console.log('filter set')
  }

  render() {
    const { events, nodes, routes } = this.props
    const { eventItem, filters } = this.state

    console.log(routes);

    let tags = []
    events.items.forEach(i =>  { tags = [...tags, ...i.tags.split(', ')] } )
    let uniqueTags = tags.filter((row, index, arr) => arr.findIndex(row2 => row2 === row) >= index);

    let months = events.items.map(i => [DateTime.fromISO(i.field_event_date).toFormat('M'), DateTime.fromISO(i.field_event_date).toFormat('LLLL')] )

    let uniqueMonths = months.filter((row, index, arr) => arr.findIndex(row2 => row2[0] === row[0]) >= index);
    console.log(uniqueMonths)


    events.items.forEach( i => { 
      i.month = DateTime.fromISO(i.field_event_date).toFormat('M'); 
      i.monthText = DateTime.fromISO(i.field_event_date).toFormat('LLLL');  
    } ) 

    let eventsByDate = Object.groupBy && Object.groupBy( events.items, ({ month }) => month )

    if (events.items.length >= 1) {
			 return (
        <div className="events" style={{backgroundColor: '#662e91', padding: '32px'}} >
	        {/* <h4 className="feature-title" style={{marginTop: 0}}>Fifty  Years of 4ZZZ Festival Program</h4> */}


          <div className="inside" style={{ }}>
            <div style={{display: 'flex', justifyContent: 'center'}}>
          { nodes['4ZZZ50-program-information'] && nodes['4ZZZ50-program-information'].body && 
            <div className='byline'>
	            <h2 className="feature-title" style={{marginTop: 0, fontFamily: 'ZedbitWeb'}}>4ZZZ50 just announced</h2>
              <div dangerouslySetInnerHTML={{ __html: nodes['4ZZZ50-program-information'].body[0].value}}></div>
            </div>
          }

            </div>


            <div className="program">
              <div className="foreward">
  {/* 
                <div className="tag-filter">
                  <div onClick={() => this.setFilter('All') } ><span className={'tag all'} >All <span style={{ fontSize: '1.5em', lineHeight: '1rem'}}>{filters.includes('All')?'■':'□'}</span></span></div>
                  {uniqueTags.map(tag => <div onClick={() => this.setFilter(tag) } ><span className={'tag ' + makeSafeForCSS(tag) } >{tag} <span style={{ fontSize: '1.5em', lineHeight: '1rem'}}>{filters.includes(tag)?'■':'□'}</span></span></div>)}
                </div> */}
              </div>
            {/* {uniqueMonths.map( i => <h3 className="monthTitle">{i[1]}</h3> ) } */}

            { routes.matches[0].match.path !== '/' ? Object.keys(eventsByDate).map((a, n) => <>

              <h3 key={n} className="monthTitle" style={{ fontFamily: 'ZedbitWeb'}}>{ uniqueMonths[uniqueMonths.findIndex( b => b[0] === a)][1] }</h3>
              <div key={n} className="event-box-wrapper" style={{ justifyContent: 'start'}}>
                
                { 
                eventsByDate[a].map( ( item, index) => {
                    if (item.tags.split(', ').some(r=> this.state.filters.includes(r))) { 
                      return item === eventItem ? <EventBox key={index} event={eventItem} /> :  <EventBoxes key={index} index={index} event={item} clickHandler={this.clicked} /> 
                    } else {return (<></>)}
                  }
                  
                ) 
                }
              </div>
            </> ) : <div>
              <div className="event-box-wrapper">
                { events.items.filter(f =>  f.promote && f.promote === 'True' ).map( ( item, index) =>   item === eventItem ? <EventBox key={index} event={eventItem} /> : <EventBoxes key={index} index={index} event={item} clickHandler={this.clicked} /> ) }
              </div>
            </div>  }

            {/* {eventItem && <EventBox event={eventItem} /> } */}
            {/* <div className="event-box-wrapper">
              { events.items.map( ( item, index) => <EventBoxes index={index} event={item} clickHandler={this.clicked} /> ) }
            </div> */}
          </div>
        </div>
        </div>
	    )
		} else {
			return (
      <div className="events content">
        <h1>No events listed</h1>
        <h2>Check our social media if you're expecting something to be here.</h2>
      </div>
      )
		}
  }
}

export default connect(state => ({events: state.events, nodes: state.nodes, routes: state.routes })) (FiftyEvents)
